import { makeMutation } from '../types';

type Output = boolean;

export const collectUnpaidInvoices = makeMutation<Output>(`
  mutation CollectUnpaidInvoices {
    collectUnpaidInvoices
  }
`);
